import type { LandingPageContent } from '../types'

export const FOTOWOLTAIKA_WALLBOX_SAMOCHOD_ELEKTRYCZNY: LandingPageContent = {
  slug: 'fotowoltaika-wallbox-samochod-elektryczny',
  lang: 'pl',
  topicId: 'photovoltaik-wallbox-elektroauto',
  title: 'Wallbox i samochód elektryczny: ładowanie nadwyżką solarną zamiast tankowania',
  metaDescription:
    'Dodaj wallbox od razu do zapytania fotowoltaicznego, ładuj samochód elektryczny własnym ' +
    'prądem słonecznym - bezpłatne porównanie ofert, bez lawiny telefonów.',
  keywords: [
    'wallbox fotowoltaika',
    'samochód elektryczny ładowanie słoneczne',
    'ładowanie nadwyżką fotowoltaiczną',
    'jeździć za darmo z fotowoltaiką',
    'oszczędność paliwa samochód elektryczny',
    'porównaj oferty wallbox',
  ],
  eyebrow: 'Wallbox + samochód elektryczny',
  h1: 'Wallbox i samochód elektryczny: ładowanie nadwyżką solarną zamiast tankowania',
  intro:
    'Ładowanie samochodu elektrycznego własnym prądem słonecznym, zamiast kupowania drogiego prądu ' +
    'sieciowego lub paliwa, to jeden z najsilniejszych ekonomicznych argumentów za instalacją ' +
    'fotowoltaiczną. W Roofora wystarczy dopisać wallbox bezpośrednio do zapytania fotowoltaicznego - ' +
    'bezpłatnie, bez osobnego rodzaju zlecenia, i porównać oferty zweryfikowanych firm bez lawiny ' +
    'telefonów.',
  sections: [
    { type: 'heading', text: 'Jak działa ładowanie nadwyżką fotowoltaiczną' },
    {
      type: 'paragraph',
      text:
        'Przy ładowaniu nadwyżką wallbox ładuje samochód przede wszystkim wtedy, gdy instalacja ' +
        'fotowoltaiczna produkuje więcej prądu, niż aktualnie zużywa gospodarstwo domowe - zamiast ' +
        'oddawać nadwyżkę do sieci za grosze. Technicznie potrzeba do tego co najmniej ok. 1,4 kW ' +
        'wolnej mocy fotowoltaicznej przy ładowaniu jednofazowym lub ok. 4,2 kW przy ładowaniu ' +
        'trójfazowym (standard w większości nowoczesnych samochodów elektrycznych), zwykle sterowane ' +
        'przez "inteligentny" wallbox z automatycznym przełączaniem.',
    },
    { type: 'heading', text: 'Porównanie kosztów paliwa' },
    {
      type: 'list',
      items: [
        'Prąd z fotowoltaiki: ok. 1,44-2 € na 100 km (przy ok. 18-22 kWh/100 km i koszcie wytworzenia 8-12 centów/kWh)',
        'Prąd sieciowy: ok. 4,50-6 € na 100 km (przy aktualnej cenie prądu dla gospodarstw domowych)',
        'Benzyna: ok. 16,80 € na 100 km (przy ok. 8 l/100 km i cenie ok. 2,10 €/litr)',
      ],
    },
    {
      type: 'paragraph',
      text:
        'To zewnętrzne wartości orientacyjne rynku (sierpień 2026), nie własne obliczenia Roofora - ' +
        'ceny paliwa i prądu się zmieniają, rzeczywista oszczędność zależy od Państwa indywidualnego ' +
        'zużycia i umowy.',
    },
    { type: 'heading', text: 'Wallbox po prostu razem z zapytaniem' },
    {
      type: 'paragraph',
      text:
        'Wallbox nie jest w Roofora osobnym rodzajem zlecenia, lecz opcją w ramach zapytania ' +
        'fotowoltaicznego: wystarczy w formularzu zaznaczyć, że życzą sobie Państwo wallboxa (stację ' +
        'ładowania samochodu elektrycznego), a firmy instalatorskie uwzględnią to bezpośrednio w ' +
        'ofercie. Podobnie przy doborze wielkości instalacji można podać, że planują Państwo ładować ' +
        'samochód elektryczny - to wpływa na zalecaną wielkość instalacji i magazynu energii.',
    },
    { type: 'heading', text: 'A jeśli mam już instalację fotowoltaiczną?' },
    {
      type: 'paragraph',
      text:
        'Wtedy wystarczy samo zapytanie o instalację elektryczną, aby domontować wallbox, bez ' +
        'konieczności ponownego wystawiania całej instalacji na przetarg.',
    },
  ],
  faq: [
    {
      q: 'Czy opcja wallbox w zapytaniu kosztuje dodatkowo?',
      a: 'Nie - jak każde zapytanie w Roofora, podanie wallboxa jest bezpłatne, otrzymają Państwo niewiążące oferty od kilku firm.',
    },
    {
      q: 'Czy potrzebuję magazynu energii, aby ładować samochód prądem słonecznym?',
      a: 'Niekoniecznie - ładowanie nadwyżką działa też bez magazynu, dopóki świeci słońce. Magazyn dodatkowo pomaga ładować własnym prądem także poza godzinami słonecznymi.',
    },
    {
      q: 'Mam już wallbox, potrzebuję tylko podłączenia elektrycznego - czy to też możliwe?',
      a: 'Tak - to obejmuje rodzaj zlecenia instalacja elektryczna, niezależnie od kompletnej instalacji fotowoltaicznej.',
    },
  ],
  primaryCta: { label: 'Złóż zapytanie z wallboxem', action: 'customer' },
  secondaryCta: { label: 'Tylko domontaż wallboxa?', action: 'link', href: '/instalacja-elektryczna-fotowoltaiki' },
  relatedLinks: [
    { label: 'Ile kosztuje instalacja solarna?', href: '/koszt-instalacji-fotowoltaicznej' },
    { label: 'Jak działa porównanie ofert', href: '/porownaj-oferty-fotowoltaiczne' },
    { label: 'Potrzebujesz tylko instalacji elektrycznej?', href: '/instalacja-elektryczna-fotowoltaiki' },
  ],
}
